module.exports = __webpack_public_path__ + "img/three1Green.6fac33c7.jpg";